import { FaTrashCan } from "react-icons/fa6";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { cancelRideApi } from "services/auth/rideApis";
import { useNavigate } from "react-router-dom";
import { FiMapPin, FiCalendar, FiClock, FiUser, FiUsers, FiCreditCard, FiNavigation, FiFileText } from 'react-icons/fi';
export const RideDetailsCard = ({ ride, setEdit }) => {
    const navigate = useNavigate();
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const [date, time] = new Date(ride?.date).toISOString().slice(0, 16).split("T");
    const day = days[new Date(date).getDay()];
    const handleCancelRide = async () => {
        const response = await cancelRideApi(ride.id)
        if (response) {
            navigate("/my-rides");
        }
    }
    return (
        <Card className="w-full max-w-xl mx-auto my-6">
            <CardHeader className="pb-2">
                <CardTitle className="text-xl md:text-2xl flex items-center gap-2">
                    Ride Details
                </CardTitle>
                <CardDescription className="flex flex-wrap gap-4 mt-2 text-base md:text-lg">
                    <span className="flex items-center gap-1"><FiMapPin className="w-4 h-4 text-zinc-500" /><span className="font-medium">{ride?.from}</span> → <span className="font-medium">{ride?.to}</span></span>
                    <span className="flex items-center gap-1"><FiCalendar className="w-4 h-4 text-zinc-500" /><span className="font-medium">{date}</span> <span className="text-xs">({day})</span></span>
                    <span className="flex items-center gap-1"><FiClock className="w-4 h-4 text-zinc-500" /><span className="font-medium">{time}</span></span>
                </CardDescription>
            </CardHeader>
            <Separator className="my-1" />
            <CardContent className="flex flex-col gap-2 md:gap-3 text-zinc-800">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                    <span className="text-base md:text-lg font-medium text-zinc-700 flex items-center gap-1"><FiUser className="w-5 h-5 text-zinc-500" /> Host: <span className="font-semibold text-zinc-900">{ride.host.name}</span></span>
                </div>
                <div className="flex flex-wrap gap-4 mt-2">
                    <span className="flex items-center gap-1"><FiUsers className="w-4 h-4 text-zinc-500" /><span className="font-medium">{ride?.capacity}</span> passengers</span>
                    <span className="flex items-center gap-1"><FiCreditCard className="w-4 h-4 text-zinc-500" /><span className="font-medium">{ride?.totalFare ? `₹${ride.totalFare}` : "TBD"}</span> per passenger</span>
                    <span className="flex items-center gap-1"><FiNavigation className="w-4 h-4 text-zinc-500" /><span className="font-medium">{ride?.vehicleType.charAt(0).toUpperCase() +
                        ride?.vehicleType.toLowerCase().slice(1)}</span></span>

                </div>
                {ride?.description && (
                    <div className="text-sm md:text-base text-zinc-600 mt-1 overflow-x-hidden text-wrap text-ellipsis ">
                        <span className="flex items-start gap-1"><FiFileText className="w-4 h-4 text-zinc-500 shrink-0 mt-0.5" /> <span>{ride?.description}</span></span>
                    </div>
                )}
            </CardContent>
            <CardFooter className="flex flex-col md:flex-row gap-2 md:justify-end mt-2">
                <button
                    onClick={() => { setEdit(true) }}
                    className="rounded-lg border border-input px-4 py-2 bg-background hover:bg-accent transition-colors text-sm font-medium"
                >
                    Edit Ride Details
                </button>
                <button
                    onClick={handleCancelRide}
                    className="rounded-lg border border-red-700 px-4 py-2 bg-red-500 text-white flex items-center gap-2 hover:bg-red-600 transition-colors text-sm font-medium"
                >
                    <FaTrashCan /> Cancel Ride
                </button>
            </CardFooter>
        </Card>
    );
};
